"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var emojilib_1 = require("emojilib");
var match_sorter_1 = __importDefault(require("match-sorter"));
/* build proper library with included name of the emoji */
var library = Object.entries(emojilib_1.lib).map(function (_a) {
    var name = _a[0], emojiObject = _a[1];
    return (__assign({}, emojiObject, { keywords: [name].concat(emojiObject.keywords), name: name }));
});
exports.default = (function (key) {
    return match_sorter_1.default(library, key, { keys: ["keywords"] });
});
